import { useEffect, useRef } from 'react'
import { useCogfy } from '../../../hooks'
import { useQuery } from '@tanstack/react-query'
import { popupCenter } from '../../../helpers/popup-center'
import { Button, ButtonProps } from '../../../components'
import { PlusIcon } from 'lucide-react'

type AddRdStationProps = {
  onSuccess?: () => void
}

export function AddRdStationButton (props: AddRdStationProps & ButtonProps) {
  const { onSuccess } = props

  const cogfy = useCogfy()
  const windowRef = useRef<Window | null>(null)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const data = {
    provider: 'rdStation' as const
  }

  const getRdStationAuthUrl = useQuery({
    queryKey: ['getRdStationAuthUrl', data],
    queryFn: ({ signal }) => cogfy.getRdStationAuthUrl(data, { signal })
  })

  const checkPopupClosed = () => {
    if (windowRef.current && windowRef.current.closed) {
      clearInterval(intervalRef.current!)
      intervalRef.current = null
      onSuccess?.()
    }
  }

  const openPopup = () => {
    if (getRdStationAuthUrl.data?.authUrl) {
      windowRef.current = popupCenter(getRdStationAuthUrl.data.authUrl)
      intervalRef.current = setInterval(checkPopupClosed, 200)
    }
  }

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  })

  return (
    <Button
      color={props.color}
      size={props.size || 'sm'}
      disabled={getRdStationAuthUrl.isLoading}
      onClick={openPopup}
      className={props.className}
    >
      <PlusIcon size={16} />
      {props.children}
    </Button>
  )
}
